module.exports = __webpack_public_path__ + "img/dev-tools.065b8902.svg";